import { router } from 'expo-router'
import { View } from 'react-native'
import { StyleSheet, useUnistyles } from 'react-native-unistyles'

import InitialsAvatar from '@/components/navigation/InitialsAvatar'
import StyledSearchTitle from '@/components/search/SearchStyledTitle'
import UniImage from '@/components/unistyles/UniImage'
import UniTouchableRipple from '@/components/unistyles/UniTouchableRipple'
import { stripMarkers } from '@/utils/strings'

interface Props {
  id: string
  name: string
  path: string
  userFullName: string
  thumbUri?: string | null
  extraData?: (string | undefined)[]
}

const avatarSize = 50

const FosterSearchItem = ({
  id,
  name,
  path,
  thumbUri,
  userFullName,
  extraData,
}: Props) => {
  const { theme } = useUnistyles()

  return (
    <UniTouchableRipple
      accessibilityRole="button"
      borderless={true}
      key={id + '-touchable'}
      onPress={() => {
        router.push(path)
      }}
      style={{
        borderRadius: theme.tokens.containerBorderRadius,
      }}
      testID={`search-item-${name.replaceAll('!', '')}`}
    >
      <View style={styles.container}>
        <View style={styles.textContainer}>
          <StyledSearchTitle id={id} text={name} variant="labelLarge" />
          <StyledSearchTitle
            id={id}
            style={{ color: theme.colors.secondary }}
            text={userFullName}
            variant="labelSmall"
          />
          {extraData
            ?.filter((data) => data?.includes('!!!'))
            ?.map((data) => {
              if (data) {
                return (
                  <StyledSearchTitle
                    id={id}
                    key={data}
                    style={{ color: theme.colors.secondary }}
                    text={data}
                    variant="labelSmall"
                  />
                )
              }
            })}
        </View>
        {thumbUri ? (
          <View
            style={{
              height: avatarSize,
              width: avatarSize,
            }}
          >
            <UniImage
              accessibilityIgnoresInvertColors={true}
              cachePolicy={'disk'}
              contentFit="cover"
              source={thumbUri}
              style={styles.avatar}
              transition={0}
            />
          </View>
        ) : (
          <View>
            <InitialsAvatar
              size={avatarSize}
              string={stripMarkers(name)}
              style={styles.avatar}
            />
          </View>
        )}
      </View>
    </UniTouchableRipple>
  )
}

const styles = StyleSheet.create((theme) => {
  return {
    avatar: {
      borderColor: theme.colors.cardBorder,
      borderRadius: avatarSize / 2,
      borderWidth: 2,
      height: avatarSize,
      width: avatarSize,
    },
    container: {
      alignItems: 'center',
      flexDirection: 'row',
      gap: theme.tokens.spacing[3],
      padding: theme.tokens.spacing[3],
    },
    textContainer: {
      flex: 1,
    },
  }
})

export default FosterSearchItem
